export const tableData = {
  tHead: [
    {
      key: 'province',
      dataIndex: 'province',
      title: '参评馆总数',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '优秀',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '合格',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '基本合格',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '不合格',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData1 = {
  tHead: [
    {
      key: 'province',
      dataIndex: 'province',
      title: '',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '一级馆',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '二级馆',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '三级馆',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '小计',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData2 = {
  tHead: [
    {
      key: 'province',
      dataIndex: 'province',
      title: '',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '优秀',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '合格',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '基本合格',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '不合格',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '小计',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData3 = {
  tHead: [
    {
      key: 'province',
      dataIndex: 'province',
      title: '',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '优秀',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '合格',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '基本合格',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '不合格',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '小计',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
